module.exports = __webpack_public_path__ + "media/images/weather/56_day_g-d85c029aa2f3d1fec1b815ee51fbac66.png";